import { Injectable } from '@angular/core';
import { AjaxService } from './ajax.service';
import { ViewScopeService } from './view-scope.service';
import { Router } from '@angular/router';
import { retry } from 'rxjs';

import { DICT } from './account-api.constants';

@Injectable({
	providedIn: 'root'
})
export class TranslateService {
	private userId = 0;
	private url = '';
	private _dictionary: object | any;

	private readonly STORAGE_KEY = 'user_dictionary';

	public get dictionary(): any {
		return this._dictionary ? this._dictionary : [];
	}

	private _isLoaded: boolean | any;
	public get isLoaded(): boolean | any {
		return this._isLoaded;
	}
	public set isLoaded(v: boolean | any) {
		this._isLoaded = v;
	}

	constructor(
		private ajaxServ: AjaxService,
		private viewScopeService: ViewScopeService,
		private router: Router
	) {
		this.url = this.ajaxServ.getBaseOfApi();
		console.log("URL returned: ", this.url);

		// Try loading dictionary from sessionStorage first
		const cachedDict = sessionStorage.getItem(this.STORAGE_KEY);
		if (cachedDict) {
			this._dictionary = JSON.parse(cachedDict);
			this.isLoaded = true;
		}

		if (this.url != null) {
			this.loadDictionary(); // Still fetch from API to ensure freshness
		}
	}

	public loadDictionary(): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			this.isLoaded = false;

			let id: any = this.viewScopeService.getCurrentOpertaingUserId().toString();
			if (id > 0) {
				console.log("Loading Dict, user id is: ", id);
				this.userId = id;
			}

			this.getDictionary()
				.pipe(retry(3))
				.subscribe({
					next: (response) => {
						this._dictionary = response;
						this.isLoaded = true;
						sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(response));
						resolve();
					},
					error: (error) => {
						this.router.navigate(['/error', { code: -1 }]);
						reject(error);
					},
					complete: () => {
						if (!this.isLoaded) {
							// Optional logic
						}
					},
				});
		});
	}


	private getDictionary() 
	{
		const langDefault = 'HE';
		let lang = this.viewScopeService.getCurrentOpertaingUserId().toString() === '0' ? localStorage.getItem('lang')?.toUpperCase() : langDefault;
		if (!lang) lang = langDefault;
		const url = this.url + DICT + this.userId + '/' + lang;
		return this.ajaxServ.getData(url);
	}
}
